import * as Sentry from "@sentry/vue";

export const createVuexModule = moduleDefinition => (namespace = "", parentNamespace = "") => {
  let ns = parentNamespace ? `${parentNamespace}/${namespace}` : namespace;
  ns += ns ? "/" : "";

  return {
    namespaced: !!ns,
    ...moduleDefinition(ns)
  };
};

export const clearLocalStorageWhenNewVersion = (storage, key) => store => {
  try {
    const savedStore = JSON.parse(storage.getItem(key));

    if (store.state.storeVersion !== savedStore.storeVersion) {
      storage.removeItem("vuex");
    }
  } catch (error) {
    Sentry.captureException(error);
    // eslint-disable-next-line no-empty
    // :TODO Handle the situation when user store {savedStore}
    //       does not have new property added into {store}
  }
};
